import { type WidgetSettingsDefinition } from "@repo/api";

export const CALENDAR_SETTINGS: WidgetSettingsDefinition[] = [
  {
    id: "OUTLOOK",
    title: "label.include_outlook_events",
    type: "boolean",
  },
  {
    id: "SCHEDULE",
    title: "label.include_schedule_events",
    type: "boolean",
  },
];
